<template>
  <mt-popup v-model="moduleState.issueSuccess" :modal=false popup-transition="popup-fade" class="page-module">
    <div class="suc-ico">
      <img src="../../static/image/publish_suc.png" alt="发布成功">
      <p>作品发布成功啦！</p>
    </div>

    <a href="javascript:;" class="open-story" @click="openStory()">点击查看</a>
    <div class="btns">
      <a href="javascript:;" class="btn" v-if="perfectApp()" @click="comMethods.appShare(previewSrc)">分享作品</a>
      <a href="javascript:;" class="btn" @click="close('single')">继续创作</a>
    </div>
  </mt-popup>
</template>

<script>
  import {mapState} from 'vuex';
  import store from '../store/store';
  import {ComponentName, Methods} from '../const/common';

  export default {
    name: 'issue_success',
    computed: {
      ...mapState(['moduleState'])
    },
    props: {
      previewSrc: String
    },
    store,
    data() {
      return {
        comMethods: Methods
      }
    },
    methods: {
      close(type) {
        if (type === 'single') {
          Methods.cutComponent([ComponentName.ISSUS_SUCCESS], false);
        } else {
          Methods.cutComponent('all', false);
          Methods.cutComponent([ComponentName.STORYS_LIST], true);
        }
        Methods.checkChapterHash(53);
      },
      openStory() {
        this.$emit('openStory', true);
        Methods.checkChapterHash(51);
      },
      perfectApp() {
        if (window.org_box) {
          return Methods.boxVerJudge('abox', 234);
        }
        if (window.iOSinfo) {
          return Methods.boxVerJudge('ibox', '2.11.0425');
        }
      }
    }
  }
</script>

<style scoped>
  @import "../style/css/issue_success.css";
</style>



// WEBPACK FOOTER //
// src/components/issue_success.vue